// extracted by mini-css-extract-plugin
export default {"auth_form":"wFQqaF","auth_form__info":"aF82Ab","auth_form__info__alert":"RUUCwf","auth_form__info__alert__message":"_UmGhU","auth_form__button":"mGmPvj"};